<div class="flex items-center justify-end !pr-[30px] sticky">
    <button *ngIf="step > 1" type="button" class="back-btn" (click)="onBack()">Back</button>
    <button type="button" class="next-btn" (click)="onNext()">Next</button>
  </div>
  